/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Delete_TitleInputs */



/**
* | output |
* | --- |
* | "Confirm Deletion" |
*
* @param {Context_Menu_Delete_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_delete_title = /** @type {((inputs?: Context_Menu_Delete_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Delete_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Confirmer la suppression")
	if (locale === "de") return /** @type {LocalizedString} */ ("Löschung bestätigen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Conferma eliminazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Подтвердить удаление")
	if (locale === "es") return /** @type {LocalizedString} */ ("Confirmar eliminación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("确认删除")
	if (locale === "ja") return /** @type {LocalizedString} */ ("削除を確認")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विलोपन की पुष्टि करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Confirmar exclusão")
	return /** @type {LocalizedString} */ ("Confirm Deletion")
});